import { render, staticRenderFns } from "./Ezplay.vue?vue&type=template&id=5eddefa4"
import script from "./Ezplay.vue?vue&type=script&lang=js"
export * from "./Ezplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports